import {Component, ElementRef, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NgbCalendar, NgbDate, NgbDateParserFormatter} from '@ng-bootstrap/ng-bootstrap';
import {TranslocoService} from '@ngneat/transloco';
import {
  getNgbDate
} from '@utility';

@Component({
  selector: 'app-date-range-selector',
  templateUrl: './date-range-selector.component.html',
  styleUrls: ['./date-range-selector.component.scss']
})
export class DateRangeSelectorComponent implements OnInit {

  @Input() largeInput: boolean = false;
  @Input() fromDate: NgbDate | any = null;
  @Input() toDate: NgbDate | any = null;
  @Input() maxDate: NgbDate | undefined;
  @Input() minDate: NgbDate | undefined;

  calendarEnd: NgbDate = getNgbDate(30);
  calendarStart: NgbDate = getNgbDate(-30);
  @Output() dateChanged = new EventEmitter<{ from: NgbDate | undefined, to: NgbDate | undefined }>();
  hoveredDate: NgbDate | null = null;

  constructor(public formatter: NgbDateParserFormatter, private translocoService: TranslocoService, private _eref: ElementRef, private ngbCalendar: NgbCalendar,
  ) {
  }

  ngOnInit(): void {
    if (this.maxDate) {
      this.calendarEnd = this.maxDate;
    }
    if (this.minDate) {
      this.calendarStart = this.minDate;
    }
  }

  onDateSelection(date: NgbDate): void {
    if (this.maxDate && date.after(this.maxDate)) {
      date = this.maxDate
    }
    if (this.minDate && date.before(this.minDate)) {
      date = this.minDate
    }
    if ((!this.fromDate && !this.toDate)) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate) {
      if (date.before(this.fromDate)) {
        this.toDate = this.fromDate;
        this.fromDate = date;
      } else {
        this.toDate = date;
      }
    } else if (!this.fromDate && this.toDate) {
      if (date.after(this.toDate)) {
        this.fromDate = this.toDate;
        this.toDate = date;
      } else {
        this.fromDate = date;
      }
    } else if (this.fromDate && this.toDate) {
      this.fromDate = date;
      this.toDate = null;
    }
  }


  isHovered(date: NgbDate): boolean {
    return (
      ((this.fromDate && !this.toDate) || (!this.fromDate && this.toDate)) &&
      ((this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate))
        ||
        (this.hoveredDate && date.before(this.fromDate) && date.after(this.hoveredDate))
        ||
        (this.hoveredDate && date.before(this.toDate) && date.after(this.hoveredDate))
        ||
        (this.hoveredDate && date.after(this.toDate) && date.before(this.hoveredDate)))

    );
  }

  isInside(date: NgbDate): boolean {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  isToday(date: NgbDate): boolean {
    return date.equals(this.ngbCalendar.getToday());
  }

  isDisabled(date: NgbDate): boolean {
    return date.after(this.maxDate) || date.before(this.minDate);
  }

  isRange(date: NgbDate): boolean {
    return (
      date.equals(this.fromDate) ||
      (this.toDate && date.equals(this.toDate)) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }

  getValue(): string {
    if (this.fromDate && this.toDate) {
      return (this.formatter.format(this.fromDate) + "-" + this.formatter.format(this.toDate))
    }
    if (!this.fromDate && this.toDate) {
      return this.translocoService.translate("date.range.selector.to") + " " + this.formatter.format(this.toDate)
    }
    if (!this.toDate && this.fromDate) {
      return this.translocoService.translate("date.range.selector.from") + " " + this.formatter.format(this.fromDate)
    }
    return "";
  }

  dropdownClosed(closed: boolean) {
    if (!closed) {
      this.dateChanged.emit({from: this.fromDate, to: this.toDate})
    }
  }
}
